module.exports = __webpack_public_path__ + "static/media/success-doc.eb331508.svg";